<template>
	<div class="carousel">
		<el-carousel
			indicator-position="none"
			:height="posterHeight"
			style="transition: height .3s;"
			class=""
		>
			<el-carousel-item v-for="poster in posters" :key="poster">
				<img class="poster-item" :src="poster" />
			</el-carousel-item>
		</el-carousel>
		<div class="el-carousel__mask" />
		
		<div class="slogan__warp">
			<div class="slogan slogan__top">
				<SvgIcon name="star" class-name="star-icon" />
				<div class="title">
					<div class="title__line" />
					<div class="title__text">
						{{ $t('section.poster.title') }}
					</div>
					<div class="title__line" />
				</div>
			</div>
			
			<div class="slogan slogan__title">
				<SvgIcon name="left-wheat" class-name="wheat-icon" />
				<div class="slogan__title__slogan">
					<div>{{ sloganContent[currentLang]?.line1 }}</div>
					<div>{{ sloganContent[currentLang]?.line2 }}</div>
				</div>
				<SvgIcon name="right-wheat" class-name="wheat-icon" />
			</div>
		</div>
		<div class="slogan slogan__honor">
			<div
				class="slogan__honor__list"
				v-for="(honor, hIndex) in sloganHonor"
				:key="hIndex"
			>
				<SvgIcon :name="honor.icon" class-name="honor-icon" />
				<div class="honor-title">
					<pre style="width: 100%;white-space: pre-line;margin-bottom: 0;font-family: inherit;">
						{{ honor.label }}
					</pre>
				</div>
			</div>
		</div>
<!--		<div class="slogan__warp">-->
<!--			-->
<!--			-->
<!--		</div>-->
	</div>
</template>

<script setup>
import { onMounted,onBeforeUnmount,reactive,ref,computed } from 'vue'
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import {useStore} from "vuex";

const props = defineProps({
	posters: {
		type: Array,
		default: () => []
	}
})

const store = useStore()

const container = reactive({
    width:window.innerWidth
})

const currentLang = computed(() => store.getters.currentLanguage)

const companyInfo = computed(() => store.state.companyInfo)

const sloganContent = computed(() => {
	return {
		cn: {
			line1: companyInfo.value?.banner_top_content_cn,
			line2: companyInfo.value?.banner_center_content_cn
		},
		
		en: {
			line1: companyInfo.value?.banner_top_content_en,
			line2: companyInfo.value?.banner_center_content_en
		},
		
		de: {
			line1: companyInfo.value?.banner_top_content_de,
			line2: companyInfo.value?.banner_center_content_de
		},
		
		jp: {
			line1: companyInfo.value?.banner_top_content_jp,
			line2: companyInfo.value?.banner_center_content_jp
		}
	}
})

const sloganHonor = computed(() => {
	return [
		{
			label: companyInfo.value?.[`banner_word_first_${currentLang.value}`],
			icon: 'star-banner'
		},
		{
			label: companyInfo.value?.[`banner_word_second_${currentLang.value}`],
			icon: 'star-banner'
		},
		{
			label: companyInfo.value?.[`banner_word_third_${currentLang.value}`],
			icon: 'star-banner'
		},
		{
			label: companyInfo.value?.[`banner_word_fourth_${currentLang.value}`],
			icon: 'star-banner'
		},
		{
			label: companyInfo.value?.[`banner_word_fifth_${currentLang.value}`],
			icon: 'star-banner'
		}
	]
})

const widthRatio = computed(() => {
    console.log('hahha')
    if(typeof container.width !== 'number' || isNaN(container.width))
        return 0.44

    if(container.width < 768)
        return 0.5

    return 0.44
})

const posterHeight = computed(() => {
    if(typeof container.width !== 'number' || isNaN(container.width))
        return '0px'

    return `${container.width * widthRatio.value}px`
})

const pcPosters = ref([
    require('@/assets/images/index/posters/banner.png')
])
const mobilePosters = ref([
    require('@/assets/images/index/posters/mobile_banner.png')
])

const posters = computed(() => {
	return props.posters
    // if(typeof container.width !== 'number' || isNaN(container.width)){
    //     console.log('pc')
    //     return pcPosters.value
    // }
    //
    // if(container.width < 768){
    //     console.log('mobile')
    //     return mobilePosters.value
    // }
		//
    // console.log('pc')
    // return pcPosters.value
})

function debounce(fn, wait = 50, immediate) { 
    let timer = null 
    return function(...args) { 
        const context = this 
        if (timer) clearTimeout(timer) 
        if (immediate && !timer) { 
            fn.apply(context, args) 
        } 
        
        timer = setTimeout(() => { 
            fn.apply(context, args) 
        }, wait) 
    } 
} 

function handleWindowResize(e) {
    if(typeof e.target.innerWidth !== 'number' || isNaN(e.target.innerWidth))
        return

    container.width = e.target.innerWidth
}

const handleWindowResizeWithDebounce = debounce(handleWindowResize,300)

onMounted(() => {
    window.addEventListener('resize', handleWindowResizeWithDebounce)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleWindowResizeWithDebounce)
})
</script>

<style lang="less">
    .poster-item {
        width: 100%;
    }
    
    .el-carousel__mask {
	    background-color: rgba(0, 0, 0, .7);
    }
    
    .carousel {
	    position: relative;
	    
	    .slogan__warp {
		    width: 100%;
		    //height: 100%;
		    position: absolute;
		    z-index: 1;
		    color: #fff;
		    top: 45%;
		    left: 50%;
		    transform: translate(-50%, -45%);
	    }
	    
	    .slogan {
		    color: #fff;
		    &__top {
			    display: flex;
			    flex-direction: column;
			    justify-content: center;
			    align-items: center;
			    
			   .star-icon {
				   width: 188px;
				   height: 36px;
			   }
			    
			    .title {
				    margin-top: 16px;
				    font-size: 18px;
				    display: flex;
				    align-items: center;
				    
				    &__text {
					    margin: 0 12px;
				    }
				    
				    &__line {
					    width: 120px;
					    height: 2px;
					    background-color: #fff;
				    }
			    }
		    }
		    
		    &__title {
			    display: flex;
			    justify-content: center;
			    align-items: center;
			    
			    .wheat-icon {
				    width: 80px;
				    height: 150px;
			    }
			    
			    &__slogan {
				    font-size: 48px;
				    font-weight: 700;
				    text-align: center;
				    
				    > div:first-child {
					    margin-bottom: 8px;
				    }
			    }
			    
		    }
		    
		    &__honor {
			    width: 100%;
			    display: flex;
			    justify-content: center;
			    position: absolute;
			    bottom: 50px;
			    
			    .honor-icon {
				    width: 84px;
				    height: 72px;
			    }
			    
			    .honor-title {
				    font-size: 16px;
				    font-weight: bold;
				    width: 100%;
				    text-align: center;
				    line-height: 24px;
				    margin-top: 12px;
				    word-break: break-word;
				    word-wrap: break-word;
			    }
			    
			    &__list {
				    display: flex;
				    flex-direction: column;
				    align-items: center;
				    margin-right: 50px;
				    max-width: 112px;
				    
				    &:last-child {
					    margin-right: 0;
				    }
			    }
			    
		    }
		    
	    }
	    
    }
    
    @media only screen and (max-width: 1300px) {
	    .carousel {
		    position: relative;
		    
		    .slogan__warp {
		    }
		    
		    .slogan {
			    &__top {
				    
				    .star-icon {
					    width: 120px;
					    height: 36px;
				    }
				    
				    .title {
					    margin-top: 8px;
					    font-size: 18px;
					    
					    &__text {
						    margin: 0 12px;
					    }
					    
					    &__line {
						    width: 60px;
						    height: 2px;
					    }
				    }
			    }
			    
			    &__title {
				    
				    .wheat-icon {
					    width: 40px;
					    height: 100px;
				    }
				    
				    &__slogan {
					    font-size: 20px;
				    }
				    
			    }
			    
			    &__honor {
				    bottom: 30px;
				    
				    .honor-icon {
					    width: 32px;
					    height: 32px;
				    }
				    
				    .honor-title {
					    font-size: 14px;
					    //width: 126px;
				    }
				    
				    &__list {
					    margin-right: 30px;
				    }
				    
			    }
			    
		    }
		    
	    }
    }
    
    @media only screen and (max-width: 1024px) {
	    .carousel {
		    position: relative;
		    
		    .slogan__warp {
			    top: 30%;
		    }
		    
		    .slogan {
			    &__top {
				    
				    .star-icon {
					    width: 120px;
					    height: 36px;
				    }
				    
				    .title {
					    margin-top: 8px;
					    font-size: 16px;
					    
					    &__text {
						    margin: 0 12px;
					    }
					    
					    &__line {
						    width: 60px;
						    height: 2px;
					    }
				    }
			    }
			    
			    &__title {
				    
				    .wheat-icon {
					    width: 40px;
					    height: 80px;
				    }
				    
				    &__slogan {
					    font-size: 18px;
				    }
				    
			    }
			    
			    &__honor {
				    bottom: 30px;
				    
				    .honor-icon {
					    width: 32px;
					    height: 32px;
				    }
				    
				    .honor-title {
					    font-size: 12px;
					    max-width: 100px;
					    line-height: 14px;
				    }
				    
				    &__list {
					    margin-right: 20px;
				    }
				    
			    }
			    
		    }
		    
	    }
    }
    
    @media only screen and (max-width: 768px) {
	    .carousel {
		    position: relative;
		    
		    .slogan__warp {
		    }
		    
		    .slogan {
			    &__top {
				    
				    .star-icon {
					    width: 80px;
					    height: 36px;
				    }
				    
				    .title {
					    margin-top: 0;
					    font-size: 14px;
					    
					    &__text {
						    margin: 0 12px;
					    }
					    
					    &__line {
						    width: 60px;
						    height: 2px;
						    background-color: #fff;
					    }
				    }
			    }
			    
			    &__title {
				    
				    .wheat-icon {
					    width: 40px;
					    height: 80px;
				    }
				    
				    &__slogan {
					    font-size: 16px;
				    }
				    
			    }
			    
			    &__honor {
				    
				    .honor-title {
					    max-width: 90px;
				    }
				    
				    &__list {
					    margin-right: 20px;
				    }
			    }
			    
		    }
		    
	    }
    }
    
    @media only screen and (max-width: 535px) {
	    .carousel {
		    position: relative;
		    
		    .slogan__warp {
			    margin-top: 10%;
		    }
		    
		    .slogan {
			    &__top {
				    
				    .star-icon {
					    width: 60px;
					    height: 20px;
				    }
				    
				    .title {
					    margin-top: 0;
					    font-size: 12px;
					    
					    &__text {
						    margin: 0 12px;
					    }
					    
					    &__line {
						    width: 60px;
						    height: 1px;
						    background-color: #fff;
					    }
				    }
			    }
			    
			    &__title {
				    margin-top: 10px;
				    .wheat-icon {
					    width: 50px;
					    height: 30px;
				    }
				    
				    &__slogan {
					    font-size: 12px;
				    }
				    
			    }
			    
			    &__honor {
				    display: none;
			    }
			    
		    }
		    
	    }
    }
</style>